import React, { FC, useRef, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { FormControl, Typography } from '@mui/material';
import PrimaryBtn from '../shared/Buttons/PrimaryButton';
import i18n, { t } from 'i18next';
import TextFieldStyled from '../shared/TextFieldStyled';
import { PATTERNS } from '../../utils/constans/constans';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { SubmitButtonWrapper } from '../styled/Form/SubmitButtonWrapper';
import { AuthPageTitle } from '../shared/Typography/AuthenticationsPageTitle';
import ForgotPasswordService from '../../services/Auth/ForgotPasswordService';
import { ForgotPasswordEmailRequest } from '../../models/Authentication/ForgotPassword';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import useForgotPassword from '../../hooks/authentication/useForgotPassword';

const schema = yup.object().shape({
    emailAddress: yup
        .string()
        .required('FORM_VALIDATION_ERROR.REQUIRED')
        .matches(PATTERNS.VALID_EMAIL, 'FORM_VALIDATION_ERROR.EMAIL'),
});

export const ForgotPasswordForm: React.FC = () => {
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm<FormValues>({
        resolver: yupResolver(schema),
    });

    const { t } = useTranslation();

    const [sent, setSent] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const forgotPassword = useForgotPassword();

    const getTranslate = (key) => {
        return t(key).toString();
    };

    const onSubmit: SubmitHandler<FormValues> = (data) => {
        setIsLoading(true);
        const params: ForgotPasswordEmailRequest = {
            email: data.emailAddress,
        };
        forgotPassword
            .sendForgotPassword(params)
            .then((res) => {
                setSent(true);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <>
            <AuthPageTitle>
                {t('FORGOT_PASSWORD_PAGE.TITLE').toString()}
            </AuthPageTitle>
            {sent && (
                <Typography paragraph>
                    {t('FORGOT_PASSWORD_PAGE.SENT').toString()}
                </Typography>
            )}
            {!sent && (
                <>
                    <Typography paragraph>
                        {t('FORGOT_PASSWORD_PAGE.CONTENT').toString()}
                    </Typography>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        {/* Email address */}
                        <FormControl fullWidth>
                            <TextFieldStyled
                                type="email"
                                label={t('LOGIN_FORM_FIELDS.EMAIL').toString()}
                                error={!!errors.emailAddress}
                                {...register('emailAddress')}
                                helperText={
                                    errors.emailAddress
                                        ? getTranslate(
                                              errors.emailAddress.message
                                          )
                                        : ' '
                                }
                            />
                        </FormControl>
                        <SubmitButtonWrapper>
                            <PrimaryBtn type="submit" disabled={isLoading}>
                                {t('FORGOT_PASSWORD_PAGE.SEND').toString()}
                            </PrimaryBtn>
                        </SubmitButtonWrapper>
                    </form>
                    <Typography paragraph>
                        <Link to="/login">
                            {t('FORGOT_PASSWORD_PAGE.BACK_TO_LOGIN').toString()}
                        </Link>
                    </Typography>
                </>
            )}
        </>
    );
};

type FormValues = {
    emailAddress: string;
};
